module.exports = __webpack_public_path__ + "static/img/superhero_05.23a0535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/superhero_05.png
// module id = 9D09
// module chunks = 0